import { Dispatch, FC, SetStateAction, useState } from "react";
import { Avatar, Dropdown, Menu, message, Space, Table, Typography } from "antd";
import type { ColumnsType } from "antd/es/table";
import {
  UserSystemData,
} from "services/interface";
import { EllipsisOutlined } from "@ant-design/icons";
import ModalEditUser from "./ModalEditUser";
import ModalChangePassword from "./ModalChangePassword";
//import ModalEditDeliveryPoint from "./ModalEditDeliveryPoint";
interface TableTransportationListProps {
  data: UserSystemData[] | undefined
  onDeleteConfigs: (id: string) => void;
  limit: number;
  offset: number;
  setLimit: Dispatch<SetStateAction<number>>;
  setOffset: Dispatch<SetStateAction<number>>;
  total: string | undefined;
}

const TableDeliveryPoint: FC<TableTransportationListProps> = ({
  data,
  onDeleteConfigs,
  limit,
  offset,
  setLimit,
  setOffset,
  total,
}) => {
  const [editData, setEditData] = useState<UserSystemData | undefined>();
  const [isMoadlEdit, setIsModalEdit] = useState<boolean>(false);

  const [changePasswordData, setChangePasswordData] = useState<UserSystemData | undefined>();
  const [isModalChangePassword, setIsModalChangePassword] = useState<boolean>(false);

  const columns: ColumnsType<UserSystemData> = [
    {
      title: "ลำดับ",
      dataIndex: "index",
      align: "center",
      key: "index",
      render: (text, record, index) => index + 1,
      width: 50,
    },
    {
      title: "ชื่อ",
      dataIndex: "full_name",
      width: 150,
      render: (_text, record) => {
        return (
          <div style={{ display: "flex", flexDirection: "row", gap: 10, alignItems: "center" }} >
            <Avatar size={40} src={record.image} />
          <Typography.Link
            style={{
              cursor: "pointer",
              fontWeight: "400",
              textDecoration: "underline",
            }}
            type="secondary"
            onClick={async () => {
              setEditData(record);
              setIsModalEdit(true);
            }}
          >
            {_text}
          </Typography.Link>
          </div>
        );
      },
    },
    {
      title: "เบอร์โทร",
      dataIndex: "mobile",
      width: 250,
      render: (_text) => {
        return <Typography.Paragraph>{_text}</Typography.Paragraph>;
      },
    },
    {
      title: "อีเมล",
      dataIndex: "email",
      width: 250,
      render: (_text) => {
        return <Typography.Paragraph>{_text}</Typography.Paragraph>;
      },
    },
    {
      title: "บทบาท",
      dataIndex: "role_permission",
      width: 250,
      render: (_text) => {
        return <Typography.Paragraph>{
          _text
          }</Typography.Paragraph>;
      },
    },
    {
      title: "Action",
      dataIndex: "transection_code",
      align: "center",
      key: "transection_code",
      fixed: "right",
      width: 100,
      render: (_text, record) => (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            cursor: "pointer",
          }}
        >
          <Space size="middle">
            <Dropdown
              overlay={
                <Menu>
                  <Menu.Item
                    key="0"
                    onClick={() => {
                      if (!record.email?.trim()) {
                        message.warning("ผู้ใช้งานนี้ไม่มีอีเมล ไม่สามารถเปลี่ยนรหัสผ่านได้");
                        return;
                      }
                      setChangePasswordData(record);
                      setIsModalChangePassword(true);
                    }}
                  >
                   เปลี่ยนรหัสผ่าน
                  </Menu.Item>
                  <Menu.Item
                    key="1"
                    onClick={() => {
                      setEditData(record);
                      setIsModalEdit(true);
                    }}
                  >
                    แก้ไข
                  </Menu.Item>
                  <Menu.Item
                    key="2"
                    onClick={() => {
                      onDeleteConfigs(record.user_id);
                    }}
                  >
                    ลบ
                  </Menu.Item>
                </Menu>
              }
            >
              <div>
                <EllipsisOutlined />
              </div>
            </Dropdown>
          </Space>
        </div>
      ),
    },
  ];
  return (
    <div>
      <Table
        scroll={{ x: true }}
        columns={columns}
        dataSource={data}
        pagination={{
          pageSize: limit,
          total: parseInt(total || "0"),
          onChange: (page, pageSize) => {
            setLimit(pageSize || 10);
            setOffset((page - 1) * pageSize);
          },
        }}
      />
      <ModalEditUser
        editData={editData}
        isShow={isMoadlEdit}
        onClose={() => {
          setIsModalEdit(false);
        }}
      />
      <ModalChangePassword
        editData={changePasswordData}
        isShow={isModalChangePassword}
        onClose={() => {
          setIsModalChangePassword(false);
          setChangePasswordData(undefined);
        }}
      />
    </div>
  );
};

export default TableDeliveryPoint;
